module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (61).28278b4d.jpg";